/**
 * User: jv
 * Date: 12/05/16
 * Time: 12:56
 */
const utils = require("Sources/utils/utils");
const log = require("Sources/utils/logger")();
const CONSTANTS = require("Sources/config/constants");
const localeReq = require.context("Localization", true, /\.json$/);

var LanguageManager = {};

((LanguageManager) =>
{
  var locale = null;
  var localeMap = null;

  LanguageManager.init = function()
  {
    locale = getLocaleFromCookie();

    if(locale === null)
    {
      locale = localStorage.getItem("locale");
    }

    var tmpLocale = utils.getQueryParam("locale");
    if(!utils.isNullOrEmpty(tmpLocale))
    {
      locale = tmpLocale;
      localStorage.setItem("locale", locale);
    }

    if(utils.isNullOrEmpty(locale) || !localeExists(locale))
    {
      locale = CONSTANTS.DEFAULT_LOCALE;
    }

    $("html").addClass(locale);

    _init();
  };

  function _init()
  {
    getLocaleMap();
    applyLocale();
    $(".page-wrapper").show();

    if(utils.isFunction(LanguageManager.onInit))
    {
      LanguageManager.onInit();
    }

    if(utils.isFunction(LanguageManager.onInitGlobal))
    {
      LanguageManager.onInitGlobal();
    }
  }

  LanguageManager.onInit = null;

  LanguageManager.onInitGlobal = null;

  LanguageManager.changeLocale = function(newLocale)
  {
    if(localeExists(newLocale))
    {
      $("html").removeClass(locale).addClass(newLocale);
      locale = newLocale;
      localStorage.setItem("locale", locale);
      LanguageManager.localize();
    }
    else
    {
      throw "Locale does not exist";
    }
  };

  LanguageManager.getCurrentLocale = function()
  {
    return locale;
  };

  LanguageManager.localize = function()
  {
    if(!localeMapIsDefined() || locale !== localeMap.locale)
    {
      getLocaleMap();
      applyLocale();
    }
    else
    {
      applyLocale();
    }
  };

  function getLocaleMap()
  {
    try
    {
      log.info("Trying to fetch locale '%s'", locale);

      var localeRequire = "./" + locale + ".json";

      log.info("'%s' is in %o ? %s", localeRequire, localeReq.keys(), $.inArray(localeRequire, localeReq.keys()) !== -1);

      if($.inArray(localeRequire, localeReq.keys()) !== -1)
      {
        var tmpLocaleMap = localeReq(localeRequire);

        log.info("Successfully fetched locale map for locale [%s]: %o", locale, tmpLocaleMap);

        localeMap = tmpLocaleMap;
      }
      else if(locale !== "nl-BE" && $.inArray("./nl-BE.json", localeReq.keys()) !== -1)
      {
        $("html").removeClass(locale).addClass("nl-BE");
        locale = "nl-BE";
        localStorage.setItem("locale", locale);
        getLocaleMap(callback);
      }
      else
      {
        log.error("Couldn't find locale [%s] in known locale list: %o", locale, localeReq.keys());
        alert("Localisation could not be loaded, contact your site administrator.");
      }
    }
    catch(e)
    {
      console.error(e);
    }
  }

  function localeExists(pLocale)
  {
    var localeRequire = "./" + pLocale + ".json";

    return $.inArray(localeRequire, localeReq.keys()) !== -1;
  }

  LanguageManager.applyLocale = function(selector)
  {
    if(localeMapIsDefined() && locale === localeMap.locale)
    {
      // Add back to include the selector itself
      applyLocale($(selector).find("[data-localize]").addBack(selector).filter("[data-localize]"));
    }
  }

  function applyLocale($element)
  {
    $element = utils.isNotNull($element) ? $element : $("[data-localize]");

    $element.each(function()
    {
      var element = $(this);
      var key = $(this).data("localize");

      if(localeMapIsDefined() && localeMap.localization.hasOwnProperty(key))
      {
        changeTextOrPlaceholder(element, localeMap.localization[key]);
      }
      else
      {
        changeTextOrPlaceholder(element, key);
      }
    });



    $element = $("[data-locale]").hide();

    $element.each(function()
    {

      var element = $(this);
      var key = $(this).data("locale");

      if(key === locale)
      {
        element.show();
      }
    });

  }

  function changeTextOrPlaceholder(element, text)
  {
    if(element.is("input") || element.is("textarea"))
    {
      //element.attr("placeholder", text.toLowerCase());
      element.attr("placeholder", text);
    }
    else if(element.is("img"))
    {
      element.attr("src", text);
    }
    else
    {
      replaceNodeText(element, text);
    }
  }

  function replaceNodeText(element, text)
  {
    element.html(text);
  }

  LanguageManager.getValueForKey = function(key)
  {
    if(localeMapIsDefined() && localeMap.localization.hasOwnProperty(key))
    {
      return localeMap.localization[key];
    }
    else
    {
      return key;
    }
  };

  function localeMapIsDefined()
  {
    return utils.isObject(localeMap) && localeMap.hasOwnProperty("locale") && localeMap.hasOwnProperty("localization");
  }

  function getLocaleFromCookie()
  {
    var locale = readFromCookie("locale");

    if(locale !== null)
    {
      locale = locale.replace("_", "-");
    }

    return locale;
  }

  function readFromCookie(name)
  {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");

    for(var i = 0; i < ca.length; i++)
    {
      var c = ca[i];
      while(c.charAt(0)===" ") c = c.substring(1, c.length);
      if(c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }

    return null;
  }
})(LanguageManager);

module.exports = LanguageManager;



// WEBPACK FOOTER //
// ./app/js/services/language-manager.js